/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ms: NonNullable<unknown> }} Agents_Ping_SuccessInputs */



/**
* | output |
* | --- |
* | "Pong. Round-trip {ms} ms." |
*
* @param {Agents_Ping_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_ping_success = /** @type {((inputs: Agents_Ping_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Ping_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Pong. Antwortzeit ${i?.ms} ms.`)
	return /** @type {LocalizedString} */ (`Pong. Round-trip ${i?.ms} ms.`)
});